/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Supported setting names in the backend.
 */
export enum SettingName {
    PROPERTY_CODE_DISPLAY = 'property-code-display',
    PROPERTY_SHARING_LINKS = 'property-sharing-links',
    ADVANCED_REPORTS = 'advanced-reports',
    ALLOW_CALL_REANALYSIS = 'allow-call-reanalysis',
    ASSIGNED_PHONE = 'assigned-phone',
    ASSIGNED_PHONE_CHOOSE = 'assigned-phone-choose',
    BASE_CURRENCY = 'base-currency',
    ENABLED_CURRENCIES = 'enabled-currencies',
    BYOC_TRUNK = 'byoc-trunk',
    CALL_QUALITY = 'call-quality',
    CALL_WITHOUT_INTERNET = 'call-without-internet',
    CALL_WITHOUT_INTERNET_CHOOSE = 'call-without-internet-choose',
    CAN_RECEIVE_CALLS = 'can-receive-calls',
    COMPANY_PHONES_FALLBACK = 'company-phones-fallback',
    COUNTRY = 'country',
    CONVERSATION_PROPERTY_USER_ASSIGNMENT = 'conversation-property-user-assignment',
    CRM_PUBLISH_FEEDBACK = 'crm-publish-feedback',
    DOWNLOADS_CALLS = 'downloads-calls',
    EMPLOYEE_EXECUTION_BUFFER_WINDOW_SECONDS = 'employee-execution-buffer-window-seconds',
    FEATURE_FLAG_ADMIN_DOWNLOAD_RECORDINGS = 'feature-flag-admin-download-recordings',
    FEATURE_FLAG_AGENT_SHOW_ALL_CALLS = 'feature-flag-agent-show-all-calls',
    FEATURE_FLAG_AGENT_SHOW_ALL_CONVERSATIONS = 'feature-flag-agent-show-all-conversations',
    FEATURE_FLAG_CONVERSATIONS = 'feature-flag-conversations',
    FEATURE_FLAG_CRM = 'feature-flag-crm',
    FEATURE_FLAG_SHOW_RECORDINGS = 'feature-flag-show-recordings',
    FEATURE_FLAG_SHOW_TRANSCRIPTIONS = 'feature-flag-show-transcriptions',
    FEATURE_FLAG_BULK_CONVERSATIONS_DEDUPE = 'feature-flag-bulk-conversations-dedupe',
    FEATURE_FLAG_USE_SEARCHER_CLIENT = 'feature-flag-use-searcher-client',
    SPEED_DIALER_MAX_ATTEMPTS = 'speed-dialer-max-attempts',
    ROUTE_TO_LAST_SPEAKER = 'route-to-last-speaker',
    REPORT_DASHBOARD_LAYOUT_V1 = 'report-dashboard-layout-v1',
    REPORT_SOURCE_BREAKDOWN_PREFERENCES_V1 = 'report-source-breakdown-preferences-v1',
    SHOW_CONTACTABILITY = 'show-contactability',
    SHOW_EXACT_TOTAL_MINUTES = 'show-exact-total-minutes',
    SHOW_REPORTS = 'show-reports',
    SIMULTANEOUS_RINGING = 'simultaneous-ringing',
    TIMEOUT_ON_INCOMING = 'timeout-on-incoming',
    TIMEZONE = 'timezone',
    TWILIO_EDGE_LOCATIONS = 'twilio-edge-locations',
}
